import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { map } from 'leaflet';

i18n
  // detect user language
  // learn more: https://github.com/i18next/i18next-browser-languageDetector
  .use(LanguageDetector)
  // pass the i18n instance to react-i18next.
  .use(initReactI18next)
  // init i18next
  // for all options read: https://www.i18next.com/overview/configuration-options
  .init({
    debug: true,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    resources: {
      en: {
        translation: {
            common: {
                cancel: "Cancel",
                save: "Save",
                generate: "Generate",
                about: "About Us",
                actions: "Actions",
                quickActions: "Quick Actions",
                delete: "Delete",
                confirm: "Proceed",
                upcomingEvents: "Upcoming Events",
                climbLadder: "Climb the Ladder",
                requiredField: "Required Field. Please insert a value.",
                externalLink: "External Link",
                homeDesc1: "Lega Pauper Italia (LPI) is the leading organization for the Pauper format of Magic: The Gathering in Italy. LPI fosters competitive play and community growth through a network of affiliated leagues, local tournaments, and major events like IPT (international Pauper Tour) and Paupergeddon.",
                homeDesc2: "The Paupergeddon is LPI’s flagship event—an open, international tournament where hundreds of players compete for glory and record-breaking prize pools. It takes place three times a year: at November (Autumn Edition), at March (Winter Edition), and at June (Spring Edition), marking the pinnacle of the competitive Pauper season.",
                homeDesc3: "With its competitive spirit and inclusive nature, Paupergeddon is the ultimate battleground for Pauper enthusiasts!",
                tppInfo: "Whoever has at least 300 TPP points will be qualified for the next Top Pauper Player tournament.",
            },
            menu: {
                dashboard: "Dashboard",
                leagues: "Leagues",
                seasons: "Seasons",
                tournaments: "Tournaments",
                lpiranking: "LPI Ranking",
                lpirulebook: "LPI Rulebook",
            },
            columns: {
                name: "Name",
                startDate: "Date",
                type: "Type",
                place: "Place",
                externalLink: "External Link",
                participants: "Participants",
                turns: "Turns",
                split: "Split",
                decklist: "Decklists",
                position: "Pos.",
                positionChange: "Pos. Changes",
                player: "Player",
                lpiPoints: "LPI Points",
                lpiPointsChange: "Points Changes",
                tppPoints: "TPP Points",
                currentTppPoints: "Current TPP Points",
                topAppearances: "Top appearances",
            },
            leagues: {
                title: "Leagues",
                create: "ADD LEAGUE",
                update: "EDIT LEAGUE",
                delete: "DELETE LEAGUE",
                join: "JOIN A LEAGUE",
                leave: "LEAVE LEAGUE",
                find: "FIND A LEAGUE",
                view: "VIEW LEAGUE",
                label: "League",
                labelName: "League Name",
                labelReferral: "Referral",
                labelLpiZone: "LPI Zone",
                selectReferral: "Select Referral",
                selectZone: "Select Zone",
                selectLeague: "Select League",
                leagueName: "Name",
                referral: "Referral",
                lpiZone: "LPI Zone",
                status: "Status",
                active: "Active",
                inactive: "Inactive",
                social: "Social",
                nolocations: "There are no default locations for this league.",
                mapView: "Map",
                listView: "List",
            },
            locations: {
                title: "Locations",
                create: "ADD LOCATION",
                update: "UPDATE LOCATION",
                delete: "DELETE LOCATION",
                labelName: "Location Name",
                labelAddress: "Address",
                selectLocation: "Select Location",
                locationName: "Name",
                address: "Address",
                check: "Check if the location is already present in database:",
                noLocationStored: "Is your location not already stored in database?",
                newLocation: "Click here to create a new location",
            },
            seasons: {
                title: "Seasons",
                create: "ADD SEASON",
                update: "UPDATE SEASON",
                delete: "DELETE SEASON",
                label: "Season",
                labelName: "Season Name",
                labelStartDate: "Start Date",
                labelEndDate: "End Date",
                selectSeason: "Select Season",
                seasonName: "Season Name",
                startDate: "Start Date",
                endDate: "End Date",
                info: "Season Infos",
                participationBonus: "Participation Bonus",
                bonusCap: "Participation Bonus Cap"
            },
            stages: {
                title: "Stages",
                create: "ADD STAGE",
                update: "MANAGE STAGE",
                delete: "DELETE STAGE",
                labelName: "Stage Name",
                labelDate: "Stage Date",
                labelNumber: "Stage Number",
                labelTurns: "Swiss Rounds",
                isDone: "Completed",
                isDoneTooltip: "Flag this checkbox if the stage is completed. Unflag it if you want to reopen the stage.",
                total: "Total Stages",
                valid: "Valid Stages",
                played: "Stages Done",
            },
            tournaments: {
                title: "Tournaments",
                name: "Tournament",
                create: "ADD TOURNAMENT",
                update: "MANAGE TOURNAMENT",
                delete: "DELETE TOURNAMENT",
                attend: "Participate to a tournament",
                list: "View Tournaments",
                placeholderName: "Tournament Name",
                selectTournament: "Select Tournament",
                columnName: "Name",
                startDate: "Date",
                labelTO: "Organizing League",
                type: "Type",
                selectType: "Select Type",
                place: "Place",
                externalLink: "External Link",
                participants: "Participants",
                cap: "Players Cap",
                turns: "Swiss Rounds",
                split: "Split",
                decklist: "Decklists",
                status: "Status",
                info: "Tournament Infos",
                organizer: "Tournament Organizer",
                ranking: "Ranking",
                isDone: "Completed",
                upcoming: "Upcoming",
                isDoneTooltip: "Flag this checkbox if the tournament is completed."
            },
            players: {
                title: "Players",
                create: "ADD PLAYER",
                createNew: "NEW PLAYER",
                update: "UPDATE PLAYER",
                delete: "DELETE PLAYER",
                points: "Points",
                lpiPoints: "LPI Points",
                currentTppPoints: "Current TPP Points",
                birthDate: "Birth Date",
                playerHistory: "Player History",
                playerStats: "Player Stats",
                playedTournaments: "Tournaments Played",
                playedStages: "League's Stages Played",
                pointsStages: "Average Points per Stage",
                topAppearances: "Results",
                usedDecks: "Used Decks",
                name: "Name",
                placeholderName: "Nome Giocatore",
                placeholderRanking: "Ranking Position",
            },
            decks: {
                title: "Deck",
                name: "Deck",
                create: "ADD DECK",
                placeholder: "Deck Name",
                export: "Export",
                uploadPage: "UPLOAD DECKLIST PAGE",
                download: "DOWNLOAD DECKLIST",
                toShowJudge: "Link for HJ",
                uploadLink: "Link",
                required: "Decklists required",
                requiredTooltip: "Flag this checkbox to enable the decklist upload"
            },
          }
      },
      it: {
        translation: {
            common: {
                cancel: "Annulla",
                save: "Salva",
                generate: "Genera",
                about: "Chi Siamo",
                actions: "Azioni",
                quickActions: "Azioni Rapide",
                delete: "Elimina",
                confirm: "Procedi",
                upcomingEvents: "Prossimi Eventi",
                climbLadder: "Scala la Classifica",
                requiredField: "Campo obbligatorio. Si prega di inserire un valore opportuno.",
                externalLink: "Link Esterno",
                homeDesc1: "La Lega Pauper Italia (LPI) è l'organizzazione leader per il formato Pauper di Magic: The Gathering in Italia. LPI promuove il gioco competitivo e la crescita della comunità attraverso una rete di campionati affiliati, tornei locali ed eventi importanti come IPT (International Pauper Tour) e Paupergeddon.",
                homeDesc2: "Il Paupergeddon è l'evento di punta di LPI, un torneo internazionale aperto in cui centinaia di giocatori competono per la gloria e montepremi da record. Si svolge tre volte l'anno: a Novembre (Autumn Edition), a Marzo (Winter Edition) e a Giugno (Spring Edition), segnando l'apice della stagione competitiva del Pauper.",
                homeDesc3: " Con il suo spirito competitivo e la sua natura inclusiva, il Paupergeddon è il campo di battaglia definitivo per gli appassionati di Pauper!",
                tppInfo: "Chiunque abbia almeno 300 punti TPP sarà qualificato per il prossimo torneo Top Pauper Player.",
            },
            menu: {
                dashboard: "Dashboard",
                leagues: "Leghe",
                seasons: "Stagioni",
                tournaments: "Tornei",
                lpiranking: "Classifica LPI",
                lpirulebook: "Regolamento LPI",
            },
            columns: {
                name: "Nome",
                startDate: "Data",
                type: "Tipo",
                place: "Luogo",
                externalLink: "Link Esterno",
                participants: "Partecipanti",
                turns: "Turni",
                split: "Split",
                decklist: "Decklists",
                position: "Pos.",
                positionChange: "Variazione Pos.",
                player: "Giocatore",
                lpiPoints: "Punti LPI",
                lpiPointsChange: "Variazione Punti LPI",
                tppPoints: "Punti TPP",
                currentTppPoints: "Punti TPP Correnti",
                topAppearances: "Presenze Top",
            },
            leagues: {
                title: "Leghe",
                create: "AGGIUNGI LEGA",
                update: "AGGIORNA LEGA",
                delete: "ELIMINA LEGA",
                join: "UNISCITI A UNA LEGA",
                leave: "LASCIA LA LEGA",
                find: "CERCA UNA LEGA",
                view: "VEDI LEGA",
                label: "Lega",
                labelName: "Nome Lega",
                labelReferral: "Referente",
                labelLpiZone: "Zona LPI",
                selectReferral: "Seleziona Referente",
                selectZone: "Seleziona Zona",
                selectLeague: "Seleziona Lega",
                leagueName: "Nome",
                referral: "Referente",
                lpiZone: "Zona LPI",
                status: "Stato",
                active: "Attiva",
                inactive: "Inattiva",
                social: "Social",
                nolocations: "Non ci sono sedi predefinite per questa lega.",
                mapView: "Mappa",
                listView: "Lista",
            },
            locations: {
                title: "Sede",
                create: "AGGIUNGI SEDE",
                update: "AGGIORNA SEDE",
                delete: "ELIMINA SEDE",
                labelName: "Nome Sede",
                labelAddress: "Indirizzo",
                selectLocation: "Seleziona Sede",
                locationName: "Nome",
                address: "Indirizzo",
                check: "Controlla se la sede è già presente nel database:",
                noLocationStored: "La tua sede non è già memorizzata nel database?",
                newLocation: "Clicca qui per crearne una nuova",
            },
            seasons: {
                title: "Stagioni",
                create: "AGGIUNGI STAGIONE",
                update: "AGGIORNA STAGIONE",
                delete: "ELIMINA STAGIONE",
                label: "Stagione",
                labelName: "Nome Stagione",
                labelStartDate: "Data Inizio",
                labelEndDate: "Data Fine",
                selectSeason: "Seleziona Stagione",
                seasonName: "Nome Stagione",
                startDate: "Data Inizio",
                endDate: "Data Fine",
                info: "Informazioni",
                participationBonus: "Bonus Partecipazione",
                bonusCap: "Tetto Punti Bonus"
            },
            stages: {
                title: "Tappe",
                create: "AGGIUNGI TAPPA",
                update: "GESTISCI TAPPA",
                delete: "ELIMINA TAPPA",
                labelName: "Nome Tappa",
                labelDate: "Data Tappa",
                labelNumber: "Numero Tappa",
                labelTurns: "Turni",
                isDone: "Completato",
                isDoneTooltip: "Spunta questa casella se la tappa è conclusa. Deselezionala se vuoi riaprire la tappa.",
                total: "Tappe Totali",
                valid: "Tappe Valide",
                played: "Tappe Giocate",
            },
            tournaments: {
                title: "Tornei",
                name: "Torneo",
                create: "AGGIUNGI TORNEO",
                update: "GESTISCI TORNEO",
                delete: "ELIMINA TORNEO",
                attend: "Partecipa ad un Torneo",
                list: "Elenco Tornei",
                labelName: "Nome Torneo",
                selectTournament: "Seleziona Torneo",
                tournamentName: "Nome Torneo",
                startDate: "Data",
                labelTO: "Lega Organizzatrice",
                type: "Tipologia",
                selectType: "Seleziona Tipologia",
                place: "Luogo",
                externalLink: "Link Esterno",
                participants: "Partecipanti",
                cap: "Tetto Partecipanti",
                turns: "Turni di Svizzera",
                split: "Split",
                decklist: "Decklists",
                status: "Stato",
                info: "Informazioni",
                ranking: "Classifica",
                isDone: "Completato",
                upcoming: "Da disputare",
                isDoneTooltip: "Spunta questa casella se il torneo è concluso."
            },
            players: {
                title: "Giocatori",
                create: "AGGIUNGI GIOCATORE",
                createNew: "CREA GIOCATORE",
                update: "AGGIORNA GIOCATORE",
                delete: "ELIMINA GIOCATORE",
                points: "Punti",
                lpiPoints: "Punti LPI",
                currentTppPoints: "Punti TPP Correnti",
                birthDate: "Data di Nascita",
                playerHistory: "Storico Giocatore",
                playerStats: "Statistiche Giocatore",
                playedTournaments: "Tornei Disputati",
                playedStages: "Tappe di Lega Disputate",
                pointsStages: "Media Punti per Tappa",
                topAppearances: "Risultati",
                usedDecks: "Mazzi Utilizzati",
                name: "Nome",
                placeholderName: "Nome Giocatore",
                placeholderRanking: "Posizione Classifica",
            },
            decks: {
                title: "Mazzo",
                name: "Mazzo",
                create: "AGGIUNGI MAZZO",
                placeholder: "Nome Mazzo",
                export: "Scarica",
                uploadPage: "PAGINA INSERIMENTO DECKLIST",
                download: "SCARICA DECKLISTS",
                uploadLink: "Link",
                toShowJudge: "Link per HJ",
                required: "Decklist obbligatorie",
                requiredTooltip: "Spunta questa casella per abilitare la raccolta delle decklist"
            },
        }
      }
    }
  });

export default i18n;